"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import CarrierName from "../carrier_name";
import CarrierTypeAhead from "../carrier_typeahead";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("carrier-chooser");
function onSelectionChange(props, index) {
  props.onUpdate(_.extend(_.clone(props.state), { selectedIndex: index }));
}
function onNoCarrierSelectionChange(props) {
  props.onUpdate({
    typeAheadCarrier: null,
    selectedIndex: null
  });
}
function typeAheadCarrierSelected(props, carrier) {
  props.onUpdate({
    typeAheadCarrier: carrier,
    selectedIndex: props.carrierGuesses.length
  });
}
function typeAheadCarrierCleared(props) {
  props.onUpdate(__spreadProps(__spreadValues({}, props.state), {
    typeAheadCarrier: null
  }));
}
function guessedCarrier(props, guess, index) {
  return /* @__PURE__ */ jsxs("div", { className: bem("__choice"), children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        className: bem("__guessed-radio") + " mousetrap",
        name: "carrier",
        onChange: () => onSelectionChange(props, index),
        checked: props.state.selectedIndex === index,
        type: "radio"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: bem("__guessed-carrier"), children: [
      /* @__PURE__ */ jsx(CarrierName, { carrierID: guess.carrierID }),
      " (",
      guess.context,
      ")"
    ] })
  ] }, `guess_${guess.carrierID}`);
}
function indexCustomerOnlyDocuments(props) {
  if (props.allowIndexingCustomerOnlyDocuments) {
    return /* @__PURE__ */ jsxs("div", { className: bem("__choice"), children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          className: bem("__guessed-radio") + " mousetrap",
          name: "carrier",
          checked: props.state.selectedIndex === null,
          onChange: () => onNoCarrierSelectionChange(props),
          type: "radio"
        }
      ),
      /* @__PURE__ */ jsx("div", { className: bem("__guessed-carrier"), children: /* @__PURE__ */ jsx("p", { children: "Assign documents to load without assigning a carrier" }) })
    ] });
  }
}
export function initialCarrierChooserState() {
  return {
    selectedIndex: 0,
    typeAheadCarrier: null
  };
}
export function chosenCarrierID(state, carrierGuesses) {
  if (state.selectedIndex == null) {
    return null;
  } else if (state.selectedIndex < carrierGuesses.length) {
    return carrierGuesses[state.selectedIndex].carrierID;
  } else if (state.typeAheadCarrier) {
    return state.typeAheadCarrier.id;
  }
}
export function assignsCustomerOnlyDocuments(state) {
  if (state.selectedIndex == null) {
    return true;
  } else {
    return false;
  }
}
export default function CarrierChooser(props) {
  return /* @__PURE__ */ jsxs("div", { className: bem(), children: [
    _.map(
      props.carrierGuesses,
      (guess, index) => guessedCarrier(props, guess, index)
    ),
    /* @__PURE__ */ jsxs("div", { className: bem("__choice"), children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          className: bem("__typeahead-radio") + " mousetrap",
          name: "carrier",
          checked: props.state.selectedIndex === props.carrierGuesses.length,
          onChange: () => onSelectionChange(props, props.carrierGuesses.length),
          type: "radio"
        }
      ),
      /* @__PURE__ */ jsx("div", { className: bem("__typeahead"), children: /* @__PURE__ */ jsx(
        CarrierTypeAhead,
        {
          onSelectCarrier: (carrier) => typeAheadCarrierSelected(props, carrier),
          onClearCarrier: () => typeAheadCarrierCleared(props),
          onFocus: () => onSelectionChange(props, props.carrierGuesses.length),
          carrier: props.state.typeAheadCarrier
        }
      ) })
    ] }),
    indexCustomerOnlyDocuments(props)
  ] });
}
